import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'oxe';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Houve um erro. Tente novamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-oxe-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="oxe-form-container">
            <Row className="oxe-form-header">
              <h3>Oxente.net - Portal de Acesso</h3>
            </Row>
            <Row className="oxe-form-body">
              <Col sm="12" xs="12" md="12" className="oxe-input">
                <Input
                  className="user-input-oxe"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeHolder="Usuário"
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="oxe-input">
                <Input
                  className="pass-input-oxe"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeHolder="Senha"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" style={{ marginTop: '20px' }}>
                {!onLogin ? (
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-oxe"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={error.open}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
